module.exports = __webpack_public_path__ + "3f16e137/img/share-action-icon.9c12578c.svg";